import dayjs from 'dayjs';
import orderBy from 'lodash-es/orderBy';
import { GENERAL_DATE_FORMAT } from '@hems/util/src/constant/date';
import { getSortNameAndOrder } from '@hems/util/src/helper/helper';
export const getTimeStamp = () => dayjs().format(GENERAL_DATE_FORMAT);
export const getCommonResponseData = (data, path, options = {}) => {
    return {
        code: 200,
        status: 'OK',
        message: 'Success.',
        timestamp: getTimeStamp(),
        path,
        data,
        ...options,
    };
};
export const getPagingData = (listData, pageNumber, listSize) => {
    const startIndex = listSize * (pageNumber - 1);
    const endIndex = startIndex + listSize;
    return listData.slice(startIndex, endIndex);
};
export const getSortingData = (listData, sort) => {
    const { sortColumnName, isAscending } = getSortNameAndOrder(sort);
    return orderBy(listData, [sortColumnName], [isAscending ? 'asc' : 'desc']);
};
